import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class StaffsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      nickname: null,
      civil_state: null,
      email: null,
      ddd_1: null,
      phone_1: null,
      ddd_2: null,
      phone_2: null,
      address: null,
      number: null,
      complement: null,
      city: null,
      state: null,
      country: null,
      cep: null,
      cpf: null,
      identity: null,
      id_uf: null,
      id_date: null,
      id_exp: null,
      date_of_birth: null,
      neighborhood: null,
      naturality: null,
      scholarly: null,
      mother: null,
      father: null,
      confidence_us: null,
      expire_us: null,
      confidence_eu: null,
      expire_eu: null,
      photo: '',
      ctps: null,
      ctps_serial: null,
      ctps_expedition: null,
      ctps_uf: null,
      pis: null,
      blood_type: null,
      inscription: null,
      sispat: null,
      canac: null,
      license: null,
      hired: null,
      car_adm: null,
      car_atu: null,
      type: null,
      race: null,
      uf_birth: null,
      city_birth: null,
      country_birth: null,
      aso: null,
      electrocard: null,
      sapiens_code: null
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  add(event) {
    event.preventDefault();
    var data = new FormData();
    var photo = document.querySelector(".input-photo").files[0];
    data.append("imagem", photo);

    data.append("name", this.state.name);
    data.append("ddd_1", this.state.ddd_1);
    data.append("phone_1", this.state.phone_1);
    data.append("ddd_2", this.state.ddd_2);
    data.append("phone_2", this.state.phone_2);
    data.append("nickname", this.state.nickname);
    data.append("civil_state", this.state.civil_state);
    data.append("email", this.state.email);
    data.append("address", this.state.address);
    data.append("number", this.state.number);
    data.append("complement", this.state.complement);
    data.append("city", this.state.city);
    data.append("state", this.state.state);
    data.append("country", this.state.country);
    data.append("cep", this.state.cep);
    data.append("cpf", this.state.cpf);
    data.append("identity", this.state.identity);
    data.append("id_uf", this.state.id_uf);
    data.append("id_date", this.state.id_date);
    data.append("id_exp", this.state.id_exp);
    data.append("date_of_birth", this.state.date_of_birth);
    data.append("neighborhood", this.state.neighborhood);
    data.append("naturality", this.state.naturality);
    data.append("scholarly", this.state.scholarly);
    data.append("mother", this.state.mother);
    data.append("father", this.state.father);
    data.append("confidence_us", this.state.confidence_us);
    data.append("expire_us", this.state.expire_us);
    data.append("confidence_eu", this.state.confidence_eu);
    data.append("expire_eu", this.state.expire_eu);
    data.append("ctps", this.state.ctps);
    data.append("ctps_serial", this.state.ctps_serial);
    data.append("ctps_expedition", this.state.ctps_expedition);
    data.append("ctps_uf", this.state.ctps_uf);
    data.append("pis", this.state.pis);
    data.append("blood_type", this.state.blood_type);
    data.append("inscription", this.state.inscription);
    data.append("sispat", this.state.sispat);
    data.append("canac", this.state.canac);
    data.append("license", this.state.license);
    data.append("hired", this.state.hired);
    data.append("car_adm", this.state.car_adm);
    data.append("car_atu", this.state.car_atu);
    data.append("type", this.state.type);
    data.append("race", this.state.race);
    data.append("uf_birth", this.state.uf_birth);
    data.append("city_birth", this.state.city_birth);
    data.append("country_birth", this.state.country_birth);
    data.append("aso", this.state.aso);
    data.append("electrocard", this.state.electrocard);
    data.append("sapiens_code", this.state.sapiens_code);

    var header = this.refs.request_api.header();
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/funcionario/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({redirect_url: url});
          } else {
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
          }
        }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Tripulantes.AdicionarFuncionario.titulo}</h3>
      <Link to="/tripulantes/ativos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <h4>{this.locale.Tripulantes.AdicionarFuncionario.formulario.tituloInformacoesPessoais}</h4>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Nome}:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Apelido}:</label>
            <input type="text" className="form-control" name="nickname" value={this.state.nickname} onChange={this.handleChange.bind(this, 'nickname')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Telefone1}:</label>
            <div className="row">
              <div className="col-md-3">
                <input type="text" className="form-control" name="ddd_1" value={this.state.ddd_1} onChange={this.handleChange.bind(this, 'ddd_1')} />
              </div>
              <div className="col-md-9">
                <input type="text" className="form-control" name="phone_1" value={this.state.phone_1} onChange={this.handleChange.bind(this, 'phone_1')} />
              </div>
            </div>
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Telefone2}:</label>
            <div className="row">
              <div className="col-md-3">
                <input type="text" className="form-control" name="ddd_2" value={this.state.ddd_2} onChange={this.handleChange.bind(this, 'ddd_2')} />
              </div>
              <div className="col-md-9">
                <input type="text" className="form-control" name="phone_2" value={this.state.phone_2} onChange={this.handleChange.bind(this, 'phone_2')} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.EstadoCivil}:</label>
            <input type="text" className="form-control" name="civil_state" value={this.state.civil_state} onChange={this.handleChange.bind(this, 'civil_state')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Email}:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Naturalidade}:</label>
            <input type="text" className="form-control" name="naturality" value={this.state.naturality} onChange={this.handleChange.bind(this, 'naturality')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Escolaridade}:</label>
            <input type="text" className="form-control" name="scholarly" value={this.state.scholarly} onChange={this.handleChange.bind(this, 'scholarly')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.NomeDaMae}:</label>
            <input type="text" className="form-control" name="mother" value={this.state.mother} onChange={this.handleChange.bind(this, 'mother')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.NomeDoPai}:</label>
            <input type="text" className="form-control" name="father" value={this.state.father} onChange={this.handleChange.bind(this, 'father')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Raca}:</label>
            <input type="text" className="form-control" name="race" value={this.state.race} onChange={this.handleChange.bind(this, 'race')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Foto}:</label>
            <input type="file" name="photo" className="form-control input-photo" placeholder={this.locale.Tripulantes.AdicionarFuncionario.formulario.placeholder.Arquivo} value={this.state.photo} onChange={this.handleChange.bind(this, 'photo')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.DataDeNascimento}:</label>
            <InputMask value={this.state.date_of_birth}  maskChar={null} name="date_of_birth" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_of_birth')} placeholder="dd/mm/aaaa" />
          </div>
        </div>
        <hr/>
        <h4>{this.locale.Tripulantes.AdicionarFuncionario.formulario.tituloEndereco}</h4>
        <hr/>
        <div className="row">
          <div className="col-md-12 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Endereco}:</label>
            <input type="text" className="form-control" name="address" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Numero}:</label>
            <input type="text" className="form-control" name="number" value={this.state.number} onChange={this.handleChange.bind(this, 'number')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Complemento}:</label>
            <input type="text" className="form-control" name="complement" value={this.state.complement} onChange={this.handleChange.bind(this, 'complement')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Bairro}:</label>
            <input type="text" className="form-control" name="neighborhood" value={this.state.neighborhood} onChange={this.handleChange.bind(this, 'neighborhood')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Cidade}:</label>
            <input type="text" className="form-control" name="city" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Estado}:</label>
            <input type="text" className="form-control" name="state" value={this.state.state} onChange={this.handleChange.bind(this, 'state')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Pais}:</label>
            <input type="text" className="form-control" name="country" value={this.state.country} onChange={this.handleChange.bind(this, 'country')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CEP}:</label>
            <input type="text" className="form-control" name="cep" value={this.state.cep} onChange={this.handleChange.bind(this, 'cep')} />
          </div>
        </div>
        <hr/>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CPF}:</label>
            <input type="text" className="form-control" name="cpf" value={this.state.cpf} onChange={this.handleChange.bind(this, 'cpf')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Identidade}:</label>
            <input type="text" className="form-control" name="identity" value={this.state.identity} onChange={this.handleChange.bind(this, 'identity')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.IdentidadeUF}:</label>
            <input type="text" className="form-control" name="id_uf" value={this.state.id_uf} onChange={this.handleChange.bind(this, 'id_uf')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.IdentidadeDataDeExpedicao}:</label>
            <InputMask value={this.state.id_date}  maskChar={null} name="id_date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'id_date')} placeholder="dd/mm/aaaa" />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.PIS}:</label>
            <input type="text" className="form-control" name="pis" value={this.state.pis} onChange={this.handleChange.bind(this, 'pis')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.IdentidadeOrgaoExpeditor}:</label>
            <input type="text" className="form-control" name="id_exp" value={this.state.id_exp} onChange={this.handleChange.bind(this, 'id_exp')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CTPS}:</label>
            <input type="text" className="form-control" name="ctps" value={this.state.ctps} onChange={this.handleChange.bind(this, 'ctps')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CTPSNumeroDeSerie}:</label>
            <input type="text" className="form-control" name="ctps_serial" value={this.state.ctps_serial} onChange={this.handleChange.bind(this, 'ctps_serial')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CTPSExpedicao}:</label>
            <InputMask value={this.state.ctps_expedition}  maskChar={null} name="ctps_expedition" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'ctps_expedition')} placeholder="dd/mm/aaaa" />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CTPSUF}:</label>
            <input type="text" className="form-control" name="ctps_uf" value={this.state.ctps_uf} onChange={this.handleChange.bind(this, 'ctps_uf')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.TipoSanguineo}:</label>
            <input type="text" className="form-control" name="blood_type" value={this.state.blood_type} onChange={this.handleChange.bind(this, 'blood_type')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Matricula}:</label>
            <input type="text" className="form-control" name="inscription" value={this.state.inscription} onChange={this.handleChange.bind(this, 'inscription')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.SISPAT}:</label>
            <input type="text" className="form-control" name="sispat" value={this.state.sispat} onChange={this.handleChange.bind(this, 'sispat')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CANAC}:</label>
            <input type="text" className="form-control" name="canac" value={this.state.canac} onChange={this.handleChange.bind(this, 'canac')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Licenca}:</label>
            <input type="text" className="form-control" name="license" value={this.state.license} onChange={this.handleChange.bind(this, 'license')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Contratacao}:</label>
            <InputMask value={this.state.hired}  maskChar={null} name="hired" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'hired')} placeholder="dd/mm/aaaa" />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CargoDeAdmissao}:</label>
            <input type="text" className="form-control" name="car_adm" value={this.state.car_adm} onChange={this.handleChange.bind(this, 'car_adm')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CargoAtual}:</label>
            <input type="text" className="form-control" name="car_atu" value={this.state.car_atu} onChange={this.handleChange.bind(this, 'car_atu')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.EstadoDeNascimento}:</label>
            <input type="text" className="form-control" name="uf_birth" value={this.state.uf_birth} onChange={this.handleChange.bind(this, 'uf_birth')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.CidadeDeNascimento}:</label>
            <input type="text" className="form-control" name="city_birth" value={this.state.city_birth} onChange={this.handleChange.bind(this, 'city_birth')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.PaisDeNascimento}:</label>
            <input type="text" className="form-control" name="country_birth" value={this.state.country_birth} onChange={this.handleChange.bind(this, 'country_birth')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.ASO}:</label>
            <InputMask value={this.state.aso}  maskChar={null} name="aso" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'aso')} placeholder="dd/mm/aaaa" />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Tripulantes.AdicionarFuncionario.formulario.Eletrocardiograma}:</label>
            <InputMask value={this.state.electrocard}  maskChar={null} name="electrocard" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'electrocard')} placeholder="dd/mm/aaaa" />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Tripulantes.AdicionarFuncionario.formulario.botaoAdicionarFuncionario}</button>
      </form>
      </div>
  </div>
</div>
    );
  }
}

export default StaffsAdd;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsAdd.js